export enum DeliveryNoteVerifyStatus {
    Passed = 'Passed',
    NeedsReview = 'NeedsReview',
    Rejected = 'Rejected',
    Pending = 'Pending',
    ManualVerificationNeeded = 'ManualVerificationNeeded',
}